(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@vue/babel-helper-vue-jsx-merge-props", "./index.less", "../_util"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@vue/babel-helper-vue-jsx-merge-props"), require("./index.less"), require("../_util"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.babelHelperVueJsxMergeProps, global.index, global._util);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _babelHelperVueJsxMergeProps, _index, _util) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _babelHelperVueJsxMergeProps = _interopRequireDefault(_babelHelperVueJsxMergeProps);
  var _default2 = {
    name: 'nx-image',
    props: {
      src: String,
      fit: String,
      alt: {
        type: String,
        default: ''
      },
      round: Boolean,
      width: [Number, String],
      height: [Number, String],
      radius: [Number, String],
      lazyLoad: Boolean,
      showError: {
        type: Boolean,
        default: true
      },
      showLoading: {
        type: Boolean,
        default: true
      },
      webp: {
        type: Boolean,
        default: false
      },
      loadingIcon: {
        type: String,
        default: 'image'
      },
      loadingStyle: {
        type: Object,
        default: function _default() {
          return {
            width: '100%',
            height: '100%'
          };
        }
      }
    },
    data: function data() {
      return {
        loading: true,
        error: false,
        calSrc: ''
      };
    },
    watch: {
      src: {
        handler: function handler(val) {
          var _this = this;

          this.loading = true;
          this.error = false;
          var isGaiaVivofs = val.indexOf('gaia-vivofs.vivo.com.cn') > -1;
          var isGaiaXy = val.indexOf('gaia-xy.vivo.com.cn') > -1;

          if (!this.webp || !this.canUseWebp() || !(isGaiaVivofs || isGaiaXy)) {
            this.calSrc = val;
            return;
          }

          var isPngOrJpg = val && (val.indexOf('.png') > -1 || val.indexOf('.jpg') > -1 || val.indexOf('.jpeg') > -1);

          if (isPngOrJpg && val.indexOf('.webp') === -1 && val.indexOf('@base@tag=imgScale&F=WEBP') === -1) {
            var suffix = isGaiaVivofs || isGaiaXy ? '.webp' : '';
            var webpUrl = val + suffix;
            var img = new Image();
            img.src = webpUrl;

            img.onerror = function () {
              _this.error = false;
              _this.loading = true;
              _this.calSrc = val;
              img = null;
            };

            img.onload = function () {
              _this.error = false;
              _this.loading = true;
              _this.calSrc = webpUrl;
            };
          } else {
            this.calSrc = val;
          }
        },
        immediate: true
      }
    },
    computed: {
      style: function style() {
        var style = {};

        if ((0, _util.isDef)(this.width)) {
          style.width = (0, _util.addUnit)(this.width);
        }

        if ((0, _util.isDef)(this.height)) {
          style.height = (0, _util.addUnit)(this.height);
        }

        if ((0, _util.isDef)(this.radius)) {
          style.overflow = 'hidden';
          style.borderRadius = (0, _util.addUnit)(this.radius);
        }

        return style;
      },
      loadingImage: function loadingImage() {
        return _util.isDarkMode ? 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAkCAYAAADit5awAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAASpSURBVHgB7VrbUdtAFL28vmMqQKkA8sfwilJBTAWQCgwV2FSAqSB2BZAK4vAa/mIqQFSA8sfwzDnmLiwb2Za0EkNmdGbkXe9L0tm792WLVKhQoUKFChUqFIkJKQCrq6sXKALWj46OUq1pzYkw5yPblpaWFqampn7rkPjx8XH9+Pi4N26t5eXlrcnJycbExER8c3OzfnZ2Fsk7wrR4Ym1trQkyAtZR9jJMDZxSTk9P+yD/ANU6rhpI+x6G4aderxePWggEf+U6uL/MzMzMr6ysBFIA7u7uoiI2zEuSHckjOnjRS3sMCLg4PDzsunNB5qOpY43Z6+vrGuvT09MByP1pr4nr1+3tbW/YC2OtKxQ1KR4xTtmseMJLkkHOvtO0CYJeNYD0CEUXROyjj9L2Dxn39/dXkEAZgk1e6O+g/OZ2Yt2B1Es5KGRdX3URZBhb53EuAQ2rHkkxCKRAeOtk6mFIaDSs/+Hh4VzSI7LWNfWYBg3lD3cwpHgTRWjmGgPqA9iAACfrQgqEF8kg4ksa62/GmjoNCo7/d3khqA6CfkgGKBlNq6mvpOfCKJ3vCy+SIWENvFhzzDBK2Dd3MzDv2UCCrFfGZXFxMTB1GkKWrqXHHG5SYE2r65ULuM8OipaUAF91kealIn7AraIfu2C1fzYVGNBdkL4rIwzNCBIinJLYWftdwVsnpwVIaI/ozmXFsWafwYeqHoPI0ufj5gdSsJFLgrdO1mqIB25qWx/FthkDwxdLPsR6iUpq3+6E9NOdi6FCYpwC+5m6UE0tSQHM68h7J9noWTxsYDXHScYQZG+DKErsFco/2vysIrhhWSIsRIGpxr0HeJEMcgfHlGG1CUKoG027fr9ExNc6OTlpJ8xnOFzXNRZAcM/0MZpEtPis87FJBwy75T+Er07e5IcT5dVMO6H6sZU0GcT9MkRq/mGwEciHNDCvJS+6OsLYjqQAnmUDm/dZ0uFNjOWbGb4kMFSGK7arXxc0RCbBoTUsgg/7JYMPG8gb6Nks8CV5XZ6kLcS1wQYaPkjTnjVmqOFjdg2uXV/dL67j5kKyEuwFbjJOzDi/PzO8SEaQwbSkqHXf0GZmrjruWJPIwSZ8gGr4iHJOnjYn0X1D/x584xbWyuqddDG3IxmBe/VheLekBBVSqrpA6FuDHxuowRpIKfX3mETRAaR325VeSHyIzZlLSpvaoA1IG+q7wD3ctZ5PJN9lXF57GEohmQ+EY9eAvt2CP8sHG5W4Mf5woN9rNsEkV33w0KRNpSRAmmkjItbNZmmOZBcXT2Ku/HvhJFO/ahbLqAETUOygb06T+vSVLyGxfRLqZL5CEqtrDciVN4L63h0KCVQHDfG+kuuFMiT5lY7VNKWMisL4ciB2jwknnbMvCboaGzQ2U4e581mzcbQTKGYpBCokgQZOhaBMncwfQvegLtppBtPI4eVoPGviEKy/He6M0LW2rsycjbP9/CR7Ye4vOVEGyUzQtEFaN4uh4Fj86rwD42b85jTkmnHnIMr7WDtgvqTLSDOvITUo5C8BGgI3+VDGrcsLqI021hJ4Je0s/rH+LWBecoL5FBB6wbLMBH6FChUqVKhQoYI//gIktmZxnR+6qgAAAABJRU5ErkJggg==' : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFkAAAAkCAYAAADit5awAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAUpSURBVHgB7VpdUttIEO6RZGrf1jxSGCyfAO8J4pwg5gRxTkByAuAEwAlinwBygiUniHMCybKz+xjlbbdizezXGg2WFBtkS6LYKn0PSBrPj9Xd8309bYgaNGjQoEGDBg2qhKAKEARzD1O5fH983Ck052qM8o+Pj3rctlgs+lLSl6RLGEXqtNc7un9qrtls8V4IdaaUCKW0MebApxcEh0piPv92rpRyk8f74iOFm70SdTqdaRB8u4Phh3hs2zZ99Dzvj16vFz46k6A3PA+utLcnTzxv7lIlcPwqHFYqkj1v0YchvqSmGyslZ+k+tu14nc7BJD82CBbK3EfRz32i39r6aenatvgzPSci+jNmut/0wpjrOy5tqh4hduY+lUSpSLZtdZv1kxoJkfWblEsflwki9JYjHtu6/es8LRgpSp7yflcjOHKEmcZ4eJcfGwRBHPVUDyqZtyRdCLd4XzXU9q9EBlKwzlJr+FQJhEsVojQnU8zDwt/0oVL0lQojbSQzp2A+hghGn/K9QRMjXAZmrBHQMoAGgK5aHlWIUkYGV74uov6mb2pZ37ajj5QYCBw8PDw8/ERbwPP+dsHf56udYU2hESPaGZs5vyxKcrJ1hmg6f7yXQIQdvss7YzYLZkJY8T2iNCMu2oAGy+Q+q/TaSSLVTw3B3UPaEUotL3G5oBpQki5UgZeSPv+dz/9CHqv6qfZXq3vrCs66ogehiVLjdaRuNoLyIbYhaKlPLxRVcHIhILW7zrZkBHAnFYdhp1I6pwn1mFb/MY3IzeBWLXLrUJqT+WpZNEA0xbShX1x9WPUSIe0GjFOhnpNPcmqaXdtGOvdP2Ot1QuyCh3asP+l2OxdFFgBljfG9XaoZpYxseBaCA0XWbUjTwnViiJeH4VXbsuzvy6X8wW0Y80AR2mHFT1gv7ej8GEoZGQeMeJvigOGqh/Mb9U07g0+A3e7RBaLres34N4bXLUv0u92De/MZnyYta8X5Uoo7RO2U/ocoK3yj+K/KNLZNOwOR7dMG1YYQfsbnw6QfDE6xI7RISowRCVczz9pjKgDM8xb08YqK4VnE8tmEbx2k/DlG4n+VPPY9LxhyWggDD1a9lB9Fzuvi9CBc/HHpBaGk8MlTbHTwrITwWW+5TQsf3ax6qY3Cx9W1+XwxTdIvVN2s22yPbQ1cDlwHUco6p4pRUviO7/gK/mQRi42sha8zzvflKGWHOI71u5RRD07pwogDGHht+gYquUFx6QIiulV2gl0wAX+PaWssp5bloC5dPYXUSheoA8CALZcFy0QpjEC6Uqc2jBJ3UWR9yEcvasSDVsvpriub5sb7RY/6ecxm88wzO3q1vtd+qq69CbUYmb+Q4+zxCe99QhePFW6SfFi4+lG10wZm46K2wVt4YMqmVBNwsBmDBP3ke8TO4iO+bcurJAvaqYRYh5H7XMWCgQ0NJAcKdckUwSmdzpWXKO63pmxQ/SKRqXwN2LB8Y4xLz4TEuWO9Ax1ORbH7op3rIQZ1GDnDsXxa4yvnypsG8Mthq96ARuLaMIx7S2uO2uDvJyt1cOTJttW4RCf2dRCoPtjM1esrqgJ1cnKYiNd1kc4sctgBLJ5t+tXA9zgRXm7mWnakMcj21bi0Toj1hBCvTzuiBiNzVcy+Xi7/nWwjFNwXvzqDUugq1fyEcZMVlfwKI5Xe1jlwkCBTobtdhdSgkt+C9A+q4hx14YlJ63YFaCOOfIjQ9Tb5sf63AHFCOwKO+gGt8HRdpb4CfoMGDRo0aNCgQXn8B+DDc1p8TtwQAAAAAElFTkSuQmCC';
      },
      loadingImageIcon: function loadingImageIcon() {
        return 'data:image/png;base64,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';
      }
    },
    created: function created() {
      var $Lazyload = this.$Lazyload;

      if ($Lazyload && _util.inBrowser) {
        $Lazyload.$on('loaded', this.onLazyLoaded);
        $Lazyload.$on('error', this.onLazyLoadError);
      }
    },
    beforeDestroy: function beforeDestroy() {
      var $Lazyload = this.$Lazyload;

      if ($Lazyload) {
        $Lazyload.$off('loaded', this.onLazyLoaded);
        $Lazyload.$off('error', this.onLazyLoadError);
      }
    },
    methods: {
      canUseWebp: function canUseWebp() {
        var elem = document.createElement('canvas');

        if (elem.getContext && elem.getContext('2d')) {
          return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
        } else {
          return false;
        }
      },
      slots: function slots() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';
        var props = arguments.length > 1 ? arguments[1] : undefined;
        var $slots = this.$slots,
            $scopedSlots = this.$scopedSlots;
        var scopedSlot = $scopedSlots[name];

        if (scopedSlot) {
          return scopedSlot(props);
        }

        return $slots[name];
      },
      onLoad: function onLoad(event) {
        this.loading = false;
        this.$emit('load', event);
      },
      onLazyLoaded: function onLazyLoaded(_ref) {
        var el = _ref.el;

        if (el === this.$refs.image && this.loading) {
          this.onLoad();
        }
      },
      onLazyLoadError: function onLazyLoadError(_ref2) {
        var el = _ref2.el;

        if (el === this.$refs.image && !this.error) {
          this.onError();
        }
      },
      onError: function onError(event) {
        this.error = true;
        this.loading = false;
        this.$emit('error', event);
      },
      onClick: function onClick(event) {
        this.$emit('click', event);
      },
      genPlaceholder: function genPlaceholder() {
        var h = this.$createElement;

        if (this.loading && this.showLoading) {
          if (this.slots('loading')) {
            return h("div", {
              "class": "nx-image__loading"
            }, [this.slots('loading')]);
          } else {
            if (this.loadingIcon === 'image') {
              return h("div", {
                "class": "nx-image__loading"
              }, [h("img", {
                "attrs": {
                  "width": "60%",
                  "src": this.loadingImage
                }
              })]);
            } else if (this.loadingIcon === 'icon') {
              return h("div", {
                "class": "nx-image__loading nx-image__loading-icon"
              }, [h("img", {
                "style": this.loadingStyle,
                "attrs": {
                  "src": this.loadingImageIcon
                }
              })]);
            } else if (this.loadingIcon) {
              return h("div", {
                "class": "nx-image__loading"
              }, [h("img", {
                "style": this.loadingStyle,
                "attrs": {
                  "src": this.loadingIcon
                }
              })]);
            } else {
              return h("div", {
                "class": "nx-image__loading"
              });
            }
          }
        }

        if (this.error && this.showError) {
          return h("div", {
            "class": "nx-image__error"
          }, [this.slots('error')]);
        }
      },
      genImage: function genImage() {
        var h = this.$createElement;
        var imgData = {
          class: 'nx-image__img',
          attrs: {
            alt: this.alt
          },
          style: {
            objectFit: this.fit
          }
        };

        if (this.error) {
          return;
        }

        if (this.lazyLoad) {
          return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
            "ref": "image",
            "directives": [{
              name: "lazy",
              value: this.calSrc
            }]
          }, imgData]));
        }

        if (this.showLoading && this.loading && this.loadingIcon === 'icon') {
          imgData.style.display = 'none';
        }

        return h("img", (0, _babelHelperVueJsxMergeProps.default)([{
          "attrs": {
            "src": this.calSrc
          },
          "on": {
            "load": this.onLoad,
            "error": this.onError
          }
        }, imgData]));
      }
    },
    render: function render() {
      var h = arguments[0];
      var className = this.round ? 'nx-image nx-image--round' : 'nx-image';
      return h("div", {
        "class": className,
        "style": this.style,
        "on": {
          "click": this.onClick
        }
      }, [this.genImage(), this.genPlaceholder(), this.slots()]);
    }
  };
  _exports.default = _default2;
});